import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {UserTasksPage} from "./-page/user-tasks.page";
import {UserTasksPending} from "./-page/user-tasks.pending";
import {userTasksSearchSchema} from "./-types";

// ─── Route definition ─────────────────────────────────────────────────────────

export const Route = createFileRoute("/_app/admin/users/$userId/tasks/")({
  component: RouteComponent,
  pendingComponent: UserTasksPending,
  staticData: {meta: {labelDescriptor: routeMessages.tasks}},
  validateSearch: (search) => userTasksSearchSchema.parse(search),
});

// ─── Route component wrapper ──────────────────────────────────────────────────

function RouteComponent() {
  const {userId} = useParams({strict: false}) as {userId: string};

  return <UserTasksPage userId={userId} />;
}
